export const moonpigPink = '#ffa6b6';
